module.exports = __webpack_public_path__ + "img/elvis-fandy-banner.9deb14c4.jpg";